import React from 'react'
import { graphql, Link } from 'gatsby'
import _ from 'lodash'

import { createLocationTags } from '../../services/job-location'

import Layout from '../../components/layout'
import Block from '../../components/waypoint-block'

const ThanksPage = ({ data }) => {
  const job = _.get(data, ['allPrismicJobs', 'edges', '0', 'node', 'data'])
  const locationTags = createLocationTags(job)
  return (
    <React.Fragment>
      <Layout>
        <div className="thanks optimal-width optimal-width--center">
          <Block>
            <section className="s-container t-section-heading--less-bottom">
              <h3>{job.title}</h3>
              <p className="s-careers--info-tag">
                {job?.work_type ?? 'full time'} / {locationTags[0]}
                {locationTags[1] && <br />}
                {locationTags[1]} {locationTags[2] && ' / '} {locationTags[2]}
                {job?.department && <br />}
                {job?.department}
              </p>
            </section>
          </Block>
          <Block>
            <section className="s-container group-center">
              <p>
                Thank you for your application, we will review it as soon as
                possible.
              </p>
              <Link to="/careers" className="button button--outline">
                RETURN TO CAREERS
              </Link>
            </section>
          </Block>
        </div>
      </Layout>
    </React.Fragment>
  )
}

export default ThanksPage

export const query = graphql`
  query($uid: String) {
    allPrismicJobs(filter: { uid: { eq: $uid } }) {
      edges {
        node {
          data {
            title
            country
            city
            work_type
            department
          }
        }
      }
    }
  }
`
